import React from 'react';
import {connect} from "react-redux";
import CustomPaper from "../../../shared/utils/CustomPaper";
import AuthService from '../../../../services/AuthService';
import pdfHandler from './../../../shared/utils/pdfHandler';
import PDFIcon from 'material-ui/svg-icons/image/picture-as-pdf';
import ReactTable from "react-table";
import reactTableProps from '../../../shared/utils/reactTableProps';
import Paper from 'material-ui/Paper';
import moment from '../../../shared/utils/moment_fr';
import DatePicker from 'material-ui/DatePicker';
import DateTimeFormat from '../../../shared/utils/dateTimeFormat';


class Synthese extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            observation: ""
        }
        this.Auth = new AuthService();
        this.downloadSynthese = this.downloadSynthese.bind(this);
        this.getSyntheseData = this.getSyntheseData.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleChangeObservation = this.handleChangeObservation.bind(this);
        this.textArea = React.createRef();
        this.getSyntheseData();
    }


    getSyntheseData() {
        this.Auth.fetch('/societe/synthese')
            .then(res => {
                this.setState({data: res.data})
            });
    }

    downloadSynthese() {
        this.Auth.fetch("/services/pdf/synthese/", {responseType: 'arraybuffer'})
            .then(resp => pdfHandler(resp.data, 'synthèse.pdf'));
    }

    handleChangeObservation(data) {
        let observation = this.textArea.current.value;
        this.Auth.fetch("/salarie/projet_pro/observation", {
            method: 'post',
            data: {
                id_projet: data.id,
                observation: observation
            }
        })
            .then(resp => {
                data.observation = observation;
                let x = this.state.data.map(xx => xx.id === data.id ? data : xx);
                this.setState({data: x});
                window.alert("Observation mise à jour.")
            });
    }

    handleChangeDate(data) {
        const toSend = {
            id_projet: data.id,
        };
        if (data.isFinDate) {
            toSend['rea_fin'] = moment(data.rea_fin).format("YYYY-MM-DD");
        } else {
            toSend['rea_debut'] = moment(data.rea_debut).format("YYYY-MM-DD");
        }
        this.Auth.fetch("/salarie/projet_pro/date", {
            method: 'post',
            data: toSend
        })
            .then(resp => {
                const x = this.state.data.map(xx => xx.id === data.id ? data : xx);
                this.setState({data: x})
            });
    }


    render() {
        return (
            <CustomPaper title="Synthèse des plans d'actions">
                <a onClick={this.downloadSynthese} style={{verticalAlign: "top", cursor: 'pointer', color: 'brown'}}>Exporter
                    la synthèse en PDF: <PDFIcon/></a>
                <ReactTable

                    filterable
                    defaultFilterMethod={(filter, row) => {
                        let row_value = row[filter.id].toUpperCase();
                        let filter_value = filter.value.toUpperCase();
                        return (row_value.indexOf(filter_value) > -1);
                    }
                    }
                    {...reactTableProps}
                    data={this.state.data}
                    columns={[
                        {
                            Header: "Salarié",
                            columns: [
                                {
                                    Header: "Numéro",
                                    accessor: "num_salarie",
                                    maxWidth: 69
                                },
                                {
                                    Header: "Nom",
                                    accessor: "nom",
                                    maxWidth: 100
                                },
                                {
                                    Header: "Prénom",
                                    accessor: "prenom",
                                    maxWidth: 100
                                },
                                {
                                    Header: "Echéance",
                                    accessor: "echeance",
                                    maxWidth: 85,
                                    Filter: ({filter, onChange}) =>
                                        <select
                                            onChange={event => onChange(event.target.value)}
                                            style={{width: "100%"}}
                                            value={filter ? filter.value : ''}
                                        >
                                            <option key={999} value=''>Toutes</option>
                                            {this.props.params_echeances.map(
                                                e => <option key={e.id} value={e.echeance}>{e.echeance}</option>
                                            )}
                                        </select>
                                },
                            ]
                        },
                        {
                            Header: "Projet Professionnel",
                            columns: [
                                {
                                    Header: "Moyens à mobiliser",
                                    accessor: (row) => {
                                        return row.moyens_a_mobiliser.split('<br>')[0]
                                    },
                                    id: 'moyens_a_mobiliser',
                                    maxWidth: 350,
                                    Filter: ({filter, onChange}) =>
                                        <select
                                            onChange={event => onChange(event.target.value)}
                                            style={{width: "100%"}}
                                            value={filter ? filter.value : ''}
                                        >
                                            <option key={999} value=''>Tous les moyens</option>
                                            {this.props.params_moyens_a_mobiliser.map(
                                                e => <option key={e.id} value={e.moyen}>{e.moyen}</option>
                                            )}
                                        </select>
                                },
                                {
                                    Header: "Projet",
                                    accessor: "projet_pro_defini",
                                }

                            ]
                        }
                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                    SubComponent={row => {
                        let data = row.original;
                        console.log("Displaying row");
                        return (
                            <Paper style={{padding: "20px"}} zDepth={5}>
                                <div className={'row'}>
                                    <div className={'col'}>
                                        <label className={'text-primary'}>Projet défini :</label>
                                        <p>{data.projet_pro_defini}</p>
                                        <label className={'text-primary'}>Domaine d'activité visé :</label>
                                        <p>{data.domaine_activite_visee}</p>
                                        <label className={'text-primary'}>Compétence à développer :</label>
                                        <p>{data.competences_a_developper}</p>
                                        <label className={'text-primary'}>Moyen à mobiliser :</label>
                                        <p dangerouslySetInnerHTML={{__html: data.moyens_a_mobiliser}}/>
                                        <label className={'text-primary'}>Observation :</label>
                                        <textarea
                                            ref={this.textArea}
                                            style={{width: "100%"}}
                                            defaultValue={data.observation}
                                        />
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => this.handleChangeObservation(data)}
                                        >
                                            Enregistrer l'observation
                                        </button>
                                    </div>
                                    <div className={'col'}>
                                        <label className={'text-primary'}>Echéance:</label>
                                        <p className={'text-info'}>{data.echeance}</p>
                                        <label className={'text-primary'}>Période de réalisation prévue :</label>
                                        <p> Entre : <span
                                            className={'text-info'}> {moment(data.Date_debut, 'YYYY-MM-DD').format('ll')} </span> et <span
                                            className={'text-info'}> {moment(data.Date_fin, 'YYYY-MM-DD').format('ll')} </span>

                                        </p>
                                        <label className={'text-primary'}>Période de réalisation effective :</label>
                                        <div> Entre :
                                            <span>
                                            <DatePicker
                                                hintText="Veuillez préciser"
                                                DateTimeFormat={DateTimeFormat}
                                                value={data.rea_debut === "0000-00-00" ? null : new Date(data.rea_debut)}
                                                okLabel="OK"
                                                cancelLabel="Annuler"
                                                locale="fr"
                                                onChange={(x, date) => {
                                                    this.handleChangeDate({
                                                        ...data,
                                                        rea_debut: date,
                                                        isFinDate: false
                                                    });
                                                }}
                                            />
                                            
                                            </span> et
                                            <span style={{paddingLeft: 2, paddingRight: 2}}
                                            >
                                                <DatePicker
                                                    hintText="Veuillez préciser"
                                                    DateTimeFormat={DateTimeFormat}
                                                    value={data.rea_fin === "0000-00-00" ? null : new Date(data.rea_fin)}
                                                    okLabel="OK"
                                                    cancelLabel="Annuler"
                                                    locale="fr"
                                                    onChange={(x, date) => {
                                                        this.handleChangeDate({
                                                            ...data,
                                                            rea_fin: date,
                                                            isFinDate: true
                                                        });
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        <label className={'text-primary'}>Satisfation du salarié concernant ce plan
                                            d'action :</label>
                                        <p>
                                            {
                                                data.note_satisfaction_salarie && data.commentaire_satisfaction_salarie ?
                                                    data.note_satisfaction_salarie + " / 5 : " + data.commentaire_satisfaction_salarie
                                                    : "Le salarié n'a pas exprimé sa satisfaction sur son espace personnel."
                                            }
                                        </p>
                                    </div>
                                </div>
                                <br/>
                                <br/>
                            </Paper>);
                    }}
                />
            </CustomPaper>
        );
    }
}

function mapStateToProps(store) {
    return {
        params_echeances: store.params.echeances,
        params_moyens_a_mobiliser: store.params.moyens_a_mobiliser
    }
}

export default connect(mapStateToProps)(Synthese);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entreprise/Synthese.js